import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from '@/App'
import { initI18n } from '@/lib/i18n'
import '@/styles/index.css'

const container = document.getElementById('root')

if (!container) {
  throw new Error('index.html is missing #root')
}

const start = async () => {
  initI18n()

  if (__USE_MOCKS__) {
    const { startMockWorker } = await import('@/mocks/browser')
    await startMockWorker()
  }

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void start()
